module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/766b4a9cfc3b39807cc0b547476956c5.png";